module.exports = __webpack_public_path__ + "static/img/WechatIMG39.efe4d486.jpeg";